export default __webpack_public_path__ + "static/media/pet-care.ea2499bf.jpg";